export default function IconCircleFile({ color = '#1E3A8A', width = 36, height = 36, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='36' height='36' rx='18' fill={color} fillOpacity='0.1' />
      <path
        d='M14.667 22.1666H21.3337'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.667 18.8334H18.0003'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.833 10.0833V10.5C18.833 12.857 18.833 14.0355 19.5653 14.7677C20.2975 15.5 21.476 15.5 23.833 15.5H24.2497M24.6663 16.8807V19.6666C24.6663 22.8093 24.6663 24.3807 23.69 25.357C22.7138 26.3333 21.1423 26.3333 17.9997 26.3333C14.857 26.3333 13.2856 26.3333 12.3093 25.357C11.333 24.3807 11.333 22.8093 11.333 19.6666V15.8798C11.333 13.1756 11.333 11.8236 12.0714 10.9077C12.2206 10.7227 12.3891 10.5542 12.5741 10.405C13.4899 9.66663 14.842 9.66663 17.5462 9.66663C18.1342 9.66663 18.4281 9.66663 18.6973 9.76163C18.7533 9.78139 18.8082 9.80413 18.8618 9.82975C19.1193 9.95292 19.3272 10.1608 19.7429 10.5765L23.69 14.5237C24.1718 15.0054 24.4126 15.2462 24.5395 15.5525C24.6663 15.8588 24.6663 16.1994 24.6663 16.8807Z'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
